import {Component} from '@angular/core';
import {ProfileService} from '../../../services/profile.service';
import {FaqCategoryService} from '../../../services/faq-category.service';
import {FaqCategory} from '../../../model/FaqCategory';
import {Contract, StatusToStr} from '../../../model/contract';
import {Product} from '../../../model/product';
import {Contact} from '../../../model/contact';

import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {SortByProductNamePipe} from "../../../components/common/SortByProductNamePipe";
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {NgbPopover, NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {ContractAssociatedUsersComponent} from "./contract-associated-users/contract-associated-users.component";
import {RouterLink} from "@angular/router";
import {CopyDirective} from "../../../directives/copy.directive";
import {DynamicTableComponent} from "../../../components/common/dynamic-table/dynamic-table.component";

@Component({
    selector: 'app-contracts',
    imports: [
    BreadcrumbComponent,
    FaIconComponent,
    RouterLink,
    SortByProductNamePipe,
    BadgeComponent,
    CopyDirective,
    NgbTooltip,
    NgbPopover,
    ContractAssociatedUsersComponent,
    DynamicTableComponent
],
    templateUrl: './contracts.component.html',
    styleUrl: './contracts.component.scss'
})
export class ContractsComponent {

  categories: FaqCategory[];
  contracts: Contract[] = [];
  contacts: Contact[];

  tableHeaders = [
    { label: 'Logiciels' },
    { label: 'État' },
    { label: 'Contact direction de projet' },
    { label: 'Utilisateurs associés', center: true },
  ]

  constructor(private profileService: ProfileService,
              private faqCategoryService: FaqCategoryService) {
    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats;
      this.profileService.getProfile().subscribe(profile => {
        this.contacts = profile.contacts;
        this.contracts = profile.contracts.filter(c => {
          return this.getCategoryFromProduct(c.product);
        });
      });
    });
  }

  getCategoryFromProduct(p: Product): FaqCategory {
    return this.categories.find(c => {
      return c.slug.toLowerCase() === p.tag.toLowerCase();
    });
  }

  statusToStr(c: Contract): string {
    return StatusToStr.statusToStr(c);
  }
}
